import { zIndex } from '@doltech/utils/lib/constants';
import { Drawer } from 'antd';
import cl from 'classnames';
import { noop } from 'lodash';
import * as React from 'react';
import styled, { css } from 'styled-components';

import { Button } from '../../ButtonV2/ButtonV2';
import { MODEL_CLASS } from './ModelConstant';

interface DrawerModalProps extends React.HTMLAttributes<HTMLDivElement> {
  visible: boolean;
  onClose?: (e?) => void;
  children?: any;
  title?: any;
  maskClosable?: boolean;
  onOk?: any;
  okButtonText?: string;
  closable?: boolean;
  height?: string;
  bodyStyle?: any;
  headerStyle?: any;
  footer?: boolean;
  maxHeight?: string;
  transitionOpacity?: boolean;
}

export const DrawerWrapper = styled(Drawer)<{ maxHeight }>`
  .ant-drawer-content-wrapper {
    ${(p) =>
      p.forceRender &&
      css`
        transform: initial !important;
        opacity: ${p.visible ? 1 : 0};
        z-index: ${p.visible ? 60 : -1};
      `};
    border-top-left-radius: 32px;
    border-top-right-radius: 32px;
  }
  .ant-drawer-content {
    border-top-left-radius: 32px;
    border-top-right-radius: 32px;
  }
  .ant-drawer-body {
    overflow: scroll;
    max-height: ${(p) => p.maxHeight};
    padding: 16px 24px 0 !important;
  }
`;

const DrawerFooter = styled.div`
  margin-top: 24px;
`;

export const DrawerBody = styled.div<{ footer }>`
  margin-top: 8px;
  margin-bottom: ${(p) => (p.footer ? '66px' : '0px')};
`;
export const DrawerModal = ({
  onOk = noop,
  okButtonText,
  maskClosable = true,
  closable = false,
  height = 'auto',
  title,
  children,
  onClose = noop,
  visible,
  bodyStyle,
  headerStyle = { border: 'unset', paddingBottom: 0 },
  footer = true,
  maxHeight = 'auto',
  className,
  transitionOpacity = false,
  ...rest
}: DrawerModalProps) => {
  return (
    <DrawerWrapper
      maxHeight={maxHeight || 'none'}
      maskClosable={maskClosable}
      title={title}
      height={height}
      placement="bottom"
      closable={closable}
      onClose={onClose}
      visible={visible}
      key="bottom"
      bodyStyle={bodyStyle}
      headerStyle={headerStyle}
      className={cl(MODEL_CLASS, className)}
      forceRender={transitionOpacity}
      zIndex={zIndex.BOTTOM_DRAWER}
      {...rest}
    >
      {children}
      {footer && (
        <DrawerFooter>
          <Button.Primary
            onClick={(e) => {
              e.preventDefault();
              onOk();
            }}
            fullWidth
          >
            {okButtonText}
          </Button.Primary>
        </DrawerFooter>
      )}
    </DrawerWrapper>
  );
};
